export const MAX_BASE64_UPLOAD_SIZE = 5 * 1_024 * 1_024; // 5MB

// images get bigger when converted to base64
export const MAX_FILE_UPLOAD_SIZE = 4 * 1_024 * 1_024; // 4MB
